import { render, staticRenderFns } from "./PointsEarned.vue?vue&type=template&id=10028764&"
import script from "./PointsEarned.vue?vue&type=script&lang=js&"
export * from "./PointsEarned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports